import { Divider, GridItem, Text, TextInputField } from "@certn/cascadia-react";
import { components } from "@certn/legacy-api/generated-schemas/people";
import { slugify } from "@certn/utils";
import { Field, useField } from "formik";
import { Trans, useTranslation } from "react-i18next";

import { ProvinceSelect } from "../../../../components/AddressInput";

type AustraliaLicenceCheckField =
  components["schemas"]["AustraliaLicenceCheckField"];

export function AustraliaLicenceInputField({
  field: config,
}: {
  field: AustraliaLicenceCheckField;
}) {
  const { t } = useTranslation();
  const [, meta, helpers] = useField(config.name);

  const handleLicenceNumberChange = (value: string) => {
    // when user clears licence number, clear the province as well,
    // making the whole field not required
    if (!value && !config.required) {
      helpers.setValue(null);
    } else {
      helpers.setValue({
        issuing_state_province_or_territory: "",
        ...meta.value,
        number: value,
      });
    }
  };

  return (
    <>
      <GridItem>
        <Text style="form/section-heading">
          {config.label}{" "}
          {!config.required && (
            <>
              (<Trans>optional</Trans>)
            </>
          )}
        </Text>
      </GridItem>

      <GridItem>
        <Field
          as={TextInputField}
          name={`${config.name}.number`}
          label={t("Licence No.")}
          value={meta.value?.number ?? ""}
          onChange={handleLicenceNumberChange}
          isRequired
          testID={`australia-licenses-${slugify(config.name)}-number-input`}
        />
      </GridItem>

      <GridItem>
        <ProvinceSelect
          name={`${config.name}.issuing_state_province_or_territory`}
          label={t("Issuing state or territory")}
          country="AU"
          testID={`australia-licenses-${slugify(
            config.name
          )}-issuing-state-select`}
        />
      </GridItem>

      {config.name === "drivers_licence" && (
        <GridItem>
          <Divider />
        </GridItem>
      )}
    </>
  );
}
